export const HAMBURGER_MENU = 1;
export const TIME_LINK = 2;



// WEBPACK FOOTER //
// ./scripts/constants/editTimeReferrer.jsx